import { TextField, Autocomplete } from "@mui/material";
import type { SyntheticEvent } from "react";
import type {
  BooleanSelectChangedHandler,
  KeyValueOption,
} from "../../../types";

const inputStatus: KeyValueOption[] = [
  { key: 0, value: "なし" },
  { key: 1, value: "あり" },
];

type NotDamageSelectProps = {
  notDamage?: boolean | string | null;
  changedValue: BooleanSelectChangedHandler;
};

export default function NotDamageSelect({
  notDamage,
  changedValue,
}: NotDamageSelectProps) {
  const handleChange = (
    _event: SyntheticEvent,
    newValues: KeyValueOption | null,
  ) => {
    changedValue(newValues ? newValues.key === 1 : null);
  };

  const getValueForDisplay = (): KeyValueOption | null => {
    if (notDamage === true) {
      return inputStatus.find((status) => status.key === 1) || null;
    }
    if (notDamage === false) {
      return inputStatus.find((status) => status.key === 0) || null;
    }
    return null;
  };

  return (
    <Autocomplete
      fullWidth
      size="small"
      options={inputStatus}
      getOptionLabel={(sale) => sale.value}
      isOptionEqualToValue={(option, value) => option.key === value.key}
      value={getValueForDisplay()}
      renderInput={(params) => (
        <TextField {...params} name="notDamageSelect" placeholder="未入力" />
      )}
      onChange={handleChange}
    />
  );
}
